module.exports = __webpack_public_path__ + "static/media/disgusted-adult-person-eating-citrus.8645fea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/disgusted-adult-person-eating-citrus.jpg
// module id = 260
// module chunks = 1